import {useState,useEffect, ChangeEvent, useContext} from 'react';
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import TablaCategoriaProductos from './TablaCategoriaProductos';
import IngresoCategoriaProducto from './IngresoCategoriaProducto';
import { GuardarCategoria, ProductoEsperado, getCategoriaVacia } from '../../../interfaces/Sistema';
import AlertService from '../../../services/AlertService';
import CertificadoService from '../../../services/CertificadoService';
import UsuarioService from '../../../services/UsuarioService';
import CatalogService from '../../../services/CatalogService';
import { CasUserContext } from '../../../services/casUserContext';



const alertaService = new AlertService;
const catalogoService = new CatalogService();



interface opcion{
  value:string,
  label: string,
}

interface MiModalProps {
    isOpen: boolean;
    toggle: () => void;
    data: number | undefined;
}

export const ModalEditarCategoria: React.FC<MiModalProps> = ({ isOpen, toggle, data})=>{
    const[ready,SetReady] = useState(false);
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const [productosActivos,setProductosActivos] = useState<Array<ProductoEsperado>>([]) ;
    const productosOpcion:Array<opcion>= Array<opcion>()
    //const [categoriaFull, setCategoriaFull]= useState<GuardarCategoria>(()=>getCategoriaLlenaTest())
    const [categoriaFull, setCategoriaFull] = useState<GuardarCategoria>(()=>getCategoriaVacia())

    const fetchData = async () =>{
        try{
             await catalogoService.GetProductosEsperadosTodos() 
             .then((data)=>{
                if(data.status.isSuccessfully){
                    setProductosActivos(data.listData.reverse())
                    SetReady(true)
                }
             })

             await catalogoService.GetCategoriaById(data!=undefined ? data:-1,token)
           .then((data)=>
               setCategoriaFull(data.data ? data.data : getCategoriaVacia())
           )
           .catch((error)=>console.error(error))



             .catch((error) => console.error(error));               
             alertaService.hideLoading();                
        }catch(error){
          console.error('Error:',error);
        }
      };
    
  
      productosActivos.map((row)=>{
        let opc : opcion={
          value: row.idProducto.toString(),
          label: row.nombreProducto
        }
        if(opc.value!='0'){
          productosOpcion.push(opc)
        }
        
    
      })

      useEffect(() => {
        fetchData();
        },[data]);
        
    
    
      if(!ready || !(categoriaFull.categoria.iddecinvcategoria===data) ){
        return <Spinner
      color="primary"
      style={{
        height: '3rem',
        width: '3rem'
      }}
      >
        Loading...
      </Spinner>; // Mostrar un indicador de carga mientras se obtienen los datos
      }
    return(
        <Modal className='modal-lg' isOpen={isOpen} toggle={toggle} >
            <ModalHeader>Editar Categoría</ModalHeader>
            <ModalBody style={{padding:'20px'}}>
                <IngresoCategoriaProducto productosActivos={productosOpcion} categoria={categoriaFull} />
            </ModalBody>
        </Modal>
    )
}

